<script>
  import Button from './Button.svelte'
  import { snackBarStore, tenantStore } from '../state/store'
  import { checkPassword } from '../helpers/form-validation'
  import { replace } from 'svelte-spa-router'
  import { t } from '../i18n/i18n'
  import TextInput from './TextInput.svelte'

  export let amount
  export let plan
  export let priceId
  let pending = false

  let formData = {
    name: '',
    password: '',
    phone: '',
  }

  $: passwordValid = checkPassword(formData.password)
  $: formValid = passwordValid

  const createSubscription = async ({ priceId }) => {
    pending = true
    try {
     const response = await fetch('/api/subscriptions', {
        method: 'post',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({
          customerId: $tenantStore._id,
          priceId,
        }),
      })

      if (!response.ok) throw new Error($t.something_wrong_payment)

      const result = await response.json()
      if(result.plan.active) {
        const newTenant = await fetch(`/api/tenants`, {
          method: 'POST',
          body: JSON.stringify({
            _id: $tenantStore._id,
            email: $tenantStore.email,
            name: $tenantStore.name,
            plan
          })
        })
        const tenant = await newTenant.json()
        tenantStore.set(tenant)
        await fetch('/api/users', {
          method: 'POST',
          body: JSON.stringify({
            email: $tenantStore.email,
            name: formData.name,
            password: formData.password,
            phone: formData.phone,
            tenant_id: $tenantStore._id,
            role: 'admin'
          })
        })
        replace('/sign-in/')
      }
    } catch (error) {
      pending = false
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }

}

</script>

<style>

  section {
    margin: 1rem 0;
  }

  article {
    border-top: 2px solid var(--bg-grey);
    padding-top: 2rem;
    margin-top: 2rem;
  }

</style>

<section>

  <article>

    <h2>{$t.user_info}</h2>
    <TextInput
      id='name'
      label='{$t['name']}'
      type='text'
      value={formData.name}
      on:input={event => (formData.name = event.target.value)} />
    <TextInput
      id='phone'
      label='{$t['phone']}'
      type='text'
      value={formData.phone}
      on:input={event => (formData.phone = event.target.value)} />
    <div>
      <p>{$t.email}</p>
      <p>{$tenantStore.email}</p>
    </div>  
    <TextInput
      id='password'
      label='{$t['password']}'
      type='password'
      valid={passwordValid}
      toggleVisible=true
      validityMessage='{$t.valid_password_message}'
      staticMessage='{$t.password_rules}'
      value={formData.password}
      on:input={event => (formData.password = event.target.value)} />
  </article>

  <Button size='full' on:click={() => createSubscription({priceId})} disabled={!formValid || pending}>
    {$t.subscribe} (${amount / 100} CAD / month)
  </Button>

</section>

